import React, { memo } from 'react';
import { graphql } from 'gatsby';
import loadable from '@loadable/component';
import { checkExpried, loaded } from '../../utils/helpers';

const GatsbyImage = loadable(() => import('./../common/GatsbyImage'));
const CustomLink = loadable(() => import('./../common/CustomLink'));

const ImageBlock = memo(({ slice }) => {
  const isMobile = loaded && window.innerWidth <= 768;
  const {
    primary: { url, image, start_time, end_time },
    slice_type,
  } = slice;

  if (checkExpried(start_time, end_time)) return;

  return (
    <section className={slice_type}>
      <CustomLink link={url}>
        {isMobile ? (
          <GatsbyImage image={image?.thumbnails?.mobile} alt={image?.thumbnails?.mobile?.alt} />
        ) : (
          <GatsbyImage image={image} alt={image?.alt} />
        )}
      </CustomLink>
    </section>
  );
});

export default ImageBlock;

export const query = graphql`
  fragment PromotionsPageDataBodyImageBlock on PrismicPromotionsPageDataBodyImageBlock {
    primary {
      url {
        document {
          ... on PrismicBrand {
            data {
              name
              url
            }
          }
          ... on PrismicCategory {
            data {
              name
              url
            }
          }
        }
        url
        type
        link_type
        uid
      }
      image {
        gatsbyImageData(layout: FULL_WIDTH)
        alt
        thumbnails {
          mobile {
            gatsbyImageData(layout: FULL_WIDTH)
            alt
          }
        }
      }
      start_time
      end_time
    }
  }
`;
